import { render } from "./EditMedicalInsurance.vue?vue&type=template&id=89794be4&scoped=true"
import script from "./EditMedicalInsurance.vue?vue&type=script&lang=js"
export * from "./EditMedicalInsurance.vue?vue&type=script&lang=js"

import "./EditMedicalInsurance.vue?vue&type=style&index=0&id=89794be4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89794be4"]])

export default __exports__